<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-beat">
    <p class="loader"> Loading... </p>
  </ngx-spinner>
